/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_CustomInputs */



/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Standards_Preset_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_custom = /** @type {((inputs?: Standards_Preset_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "it") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "es") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Custom")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Custom")
	return /** @type {LocalizedString} */ ("Custom")
});